import { LIST_URL_SPECS, listRedirectPath } from './listUrlState';

export function ercProfileRedirectPath(id: string): string {
  return listRedirectPath(LIST_URL_SPECS.ERC_PROFILES, id);
}
